module.exports = __webpack_public_path__ + "static/purchasing-a-home-square-540w-3bc5604c65cd4539cc338278d63d074d.jpg";